import { GlobalState, UI } from '@leverege/ui-redux';
import { SHOW_OVERLAYS_KEY } from "../Constants.js";
import OverlayDetailRendererModel from "../components/OverlayDetailRendererModel.js";
export default {
  id: 'rsrc.ShowOverlays',
  name: 'Show Overlays',
  matches: {
    client: ['rsrc.gallery.RsrcSelectedDialog'],
    objectType: 'rsrc',
    use: '!contextMenu'
  },
  handles: context => {
    const {
      clientProps: {
        detail
      }
    } = context;
    return detail?.type === OverlayDetailRendererModel.TYPE;
  },
  appearance: ({
    context
  }) => {
    const {
      clientProps: {
        showOverlays
      }
    } = context;
    return {
      name: showOverlays ? 'Hide Overlays' : 'Show Overlays',
      icon: 'fa fa-fw fa-square-dashed',
      checked: showOverlays,
      checkStyle: 'toggle'
    };
  },
  perform: async ({
    context
  }) => {
    const {
      clientProps: {
        showOverlays
      }
    } = context;
    GlobalState.dispatch(UI.set(SHOW_OVERLAYS_KEY, !showOverlays));
  }
};